<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },
  created() {
    if (!sessionStorage.getItem('token')) {
      this.$store.commit('SET_USERLOGINEDINFO', {})
    }
  },
  mounted() {

  },
  beforeDestroy() {
    //   退出项目清除缓存和登录
    sessionStorage.clear()
    this.$store.commit('SET_USERLOGINEDINFO', {})
  }
}
</script>

<style lang='scss'>
@import './assets/style/_style.scss';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  overflow-x: auto;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
<style lang='scss'>
.el-menu {
    border-right: none!important;
}
.el-menu-item.is-active {
    color: #1A71FF;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}

/* 步骤条改成虚线 */
.el-steps {
  //   .is-horizontal .el-step__line{
  //     border-top: 2px dashed #CCD1DE;
  //     height: 0;
  //     background-color: transparent;
  // }

  .is-success {
    color: rgba(132, 140, 152, 1) !important;
    .is-text {
      border: none;
      background: #8cb7ff;
      color: #fff;
    }
    .el-step__line-inner {
      border: 1px dashed !important;
      border-color: rgba(26, 113, 255, 1) !important;
      border-width: 1px !important;
      width: 100% !important;
    }
    .el-step__line {
      .el-step__line-inner {
        border: 1px dashed !important;
        border-color: rgba(26, 113, 255, 1) !important;
      }
    }
  }
  // .el-icon-check {
  //   border: none;
  //   background: red;
  // }
  // .el-step__head .is-success{
  //   border-color: none !important;;
  // }
  .is-process {
    color: rgba(26, 113, 255, 1);
    .is-text {
      background: rgba(26, 113, 255, 1);
      color: #fff;
      border: none;
    }
  }
}
/* button背景色 */
.el-button--primary {
  background-color: #317DF2;
}
/* 全局 选中的submenu背景色 */
.el-menu-item.is-active {
  background-color: rgba(245, 247, 250, 1) !important;
}
</style>
<style lang="scss">
// 弹窗样式
// 弹窗从底部弹出
.dialog-fade-enter-active {
  animation: dialog-fade-in 0.3s;
}
.dialog-fade-leave-active {
  animation: dialog-fade-out 0.3s;
}
@keyframes dialog-fade-in {
  0% {
    transform: translate3d(0, 100%, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
}
.box-wrap1 {
  .el-dialog__wrapper {
    overflow: hidden !important;
  }
  .el-dialog {
    background: rgba(247, 249, 250, 1) !important;
  }
  .downloadtip {
    width: 772px;
    height: 146px;
    background: rgba(245, 245, 245, 1);
    border-radius: 4px;
    padding: 16px;
    text-align: left;
    line-height: 30px;
    .downloadtip_title {
      color: rgba(34, 34, 34, 1);
      font-size: 16px;
    }
    .downloadtip_list {
      color: rgba(112, 112, 112, 1);
      font-size: 14px;
    }
  }
  .dialogContent {
    padding: 16px 20px;
    height: 86vh;
    background: #fff;
    width: 1280px;
    margin: -40px auto 0;
    overflow-y: auto;
    .topBack {
      cursor: pointer;
      color: rgba(34, 34, 34, 1);
    }
    .dialogContent_main {
      width: 800px;
      margin: 0 auto;
    }
    .dialogContent_title {
      color: rgba(34, 34, 34, 0.85);
      font-size: 24px;
      line-height: 32px;
      font-weight: 600;
    }
    .dialogContent_titletip {
      color: rgba(34, 34, 34, 0.45);
      font-size: 14px;
      line-height: 22px;
    }
  }
}

// 只有一个menu时隐藏 先下箭头
.hideMenuI {
  .el-submenu__title i {
    color: #fff !important;
  }
}

// textarea  右下数字遮挡问题调整样式
.el-textarea {
  padding-bottom: 20px;
  // margin-bottom: 20px;
  .el-textarea__inner {
    padding-bottom: 10px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue